import React, { Component } from 'react';

import { connect } from 'react-redux';

import Dashboard from '../App/containers/dashboard/dashboard';
import Login from '../App/containers/login/login';

import { Switch, Route, Redirect, withRouter} from 'react-router-dom';

class RounteMain extends Component {


  render() {
    const isLogged = sessionStorage.getItem('token');
    // const

    const CheckRoute = ({ component: Component }) => (
      <Route render={() => (
        isLogged ?
          (<Component />) :
          (<Redirect to="/login" />)
      )} />
    )

    return (
      <Switch>
        <Route name="login" path='/login' component={Login} />
        <CheckRoute path="/dashboard" component={Dashboard} />
        <Redirect from='/' to="/login" />
      </Switch >
    )
  }
}

const mapStateToProps = state => ({
  // statistics: state.statistics
});

export default withRouter(connect(mapStateToProps)(RounteMain));




// WEBPACK FOOTER //
// ./src/config/route-main.js